import { UserListDto } from "@shared/service-proxies/service-proxies";

export class ApproverDetail {
    user: UserListDto;
    WindowNum: number;
    WindowEnum: number;
}